import { ScrollArea } from '@/components/ui/scroll-area';
import { Waves, ArrowUp, ArrowDown } from 'lucide-react';

const TidesSection = ({ tides }) => {
  const getTideIcon = (type) => {
    if (type === 'High Tide') return <ArrowUp size={18} className="tide-icon-high" />;
    if (type === 'Low Tide') return <ArrowDown size={18} className="tide-icon-low" />;
    return null;
  };

  const getTideClass = (type) => {
    if (type === 'High Tide') return 'tide-high';
    if (type === 'Low Tide') return 'tide-low';
    return '';
  };

  return (
    <div className="content-card" data-testid="tides-section">
      <div className="card-header">
        <h2>
          <Waves size={20} className="inline" /> Hunstanton Tides
        </h2>
      </div>
      <ScrollArea className="card-content">
        {tides.length > 0 ? (
          <div className="tides-list-improved">
            {tides.map((tide, index) => (
              <div 
                key={`${tide.type}-${tide.time}`} 
                className={`tide-item-improved ${getTideClass(tide.type)}`}
                data-testid={`tide-item-${index}`}
              >
                <div className="tide-header-row">
                  {getTideIcon(tide.type)}
                  <span className="tide-type">{tide.type}</span>
                </div>
                <div className="tide-details-row">
                  <span className="tide-time">{tide.time}</span>
                  <span className="tide-height">{tide.height}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">No tide information available</p>
        )}
      </ScrollArea>
    </div>
  );
};

export default TidesSection;